import React, { useEffect, useRef, useState } from 'react';
import logo from './logo.svg';
import background from '/Users/flyingtopher/Desktop/Code Citadel/Personal_Projects/Personal Website/my-app/src/Screenshot 2025-05-23 at 4.12.10 AM.png';
// import vid from '/Users/flyingtopher/Desktop/Code Citadel/Personal_Projects/Personal Website/my-app/src/WEBSITE TEST A330.mp4';
import './App.css';
import { pagesEnum } from './enums';
import ScrollProgress from './scrollProgress';
import NavBar from './navbar';
import MainNavigation from './mainNavigation';
import supabase from './client';
import { Light as SyntaxHighlighter } from 'react-syntax-highlighter';
import ReactMarkdown from 'react-markdown';

// import videoSource from "/Users/flyingtopher/Desktop/Code Citadel/Personal_Projects/Personal Website/my-app/src/3678380-hd_1920_1080_30fps.mp4";
// import vid from 'public/vid1.mp4';

function Projects(props: any) {
  // const [scrollTop, setScrollTop] = useState(0);
  //     const [scrolling, setScrolling] = useState(false);

  const [scrollYPosition, setScrollYPosition] = React.useState(0);

  const [projectID, setProjectID] = useState('');

  const [projectImagePaths, setProjectImagePaths] = useState<any>();

  const [projectText, setProjectText] = useState<any>();




  const handleScroll = () => {
    const newScrollYPosition = window.pageYOffset;
    setScrollYPosition(newScrollYPosition);
  };

  function goHome() {
    window.location.href = pagesEnum.home;
  }

  const firstDivRef = useRef<HTMLDivElement | null>(null);
  const secondDivRef = useRef<HTMLDivElement | null>(null);
  const thirdDivRef = useRef<HTMLDivElement | null>(null);
  var fheight = firstDivRef.current?.clientHeight ?? 0;
  var sheight = secondDivRef.current?.clientHeight ?? 0;



  React.useEffect(() => {
    fheight = firstDivRef.current?.clientHeight ?? 0;
    sheight = secondDivRef.current?.clientHeight ?? 0;

    if (secondDivRef.current) {
      secondDivRef.current.style.position = 'sticky';
      secondDivRef.current.style.top = `${fheight}px`;
    }

    // const onScroll = e => {
    //   setScrollTop(e.target.documentElement.scrollTop);
    //   setScrolling(e.target.documentElement.scrollTop > scrollTop);
    // };



    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
      // console.log(scrollYPosition);
    };



  }, [scrollYPosition]);


  useEffect(() => {
    getProjectAssets();
    getProjectText();
  }, [])

  // var firstdiv = document.getElementsByClassName(".mainHeader");
  // var secondiv =document.querySelector(".showCaseTitle");
  // var thirdiv = document.querySelector(".textContent");
  // const fheight = firstdiv?.clientHeight ?? 0;
  // const sheight = secondiv?.clientHeight ?? 0;
  // secondiv?.style.top = `${fheight}px`;
  // thirdiv?.style.top  = `${fheight+sheight}px`;


  async function getProjectText() {
    console.log(props.info.projectID);
    const { data, error } = await supabase
      .from('projectContent')
      .select('*').eq('projectID', props.info.projectID).order('displayOrder', { ascending: true });
    console.log(data);
    setProjectText(data);
    if (error) {
      console.log(error);
    } else {
      console.log(data);
    }
  }


  async function getProjectAssets() {
    console.log(props.info.projectID);
    const { data, error } = await supabase
      .from("projectImages")
      .select('path').eq('projectID', props.info.projectID);
    setProjectImagePaths(data);
    if (error) {
      console.log(error);

    } else {
      console.log(data);
    }
  }


  function getProjectImage(imageName: string) {
    console.log(imageName);
    const { data } = supabase
      .storage
      .from('assets')
      .getPublicUrl(imageName);
    console.log(data.publicUrl);

    return (data.publicUrl);
  }


  return (
    <div className="showCase">
      <div ref={secondDivRef} className="mainHeader">
        <h1>{props.info.title}</h1>
        <button className="taxiwayButton" onClick={() => goHome()}> back to home page </button>
        <ScrollProgress></ScrollProgress>
      </div>
      <div className="showCaseContent">
        {projectText?.map((data: any, i: any) => (
          <div key={i} className="area1">
            <div style={{ top: fheight + sheight }} className="textContent">
              {/* <h1>{data.title}</h1>
            <h2>{data.subtitle}</h2> */}
              {/* <p>{data.content}</p> */}
              <ReactMarkdown children={data.content as string}></ReactMarkdown>
            </div>
            <div className="imageCascade">
              {data.images?.map((data: any, i: any) => (
                <img src={data}></img>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Projects;
